import React, { useEffect, useState, useRef, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://p2rxju-de.myshopify.com/cart/44671911067783:1?channel=buy_button';
const heroTestimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  role: 'Dueña Estética — Buenos Aires',
  quote: 'Sumé Brow Extensions a mi salón en Recoleta y estoy trabajando con +50 clientas nuevas estoy muy feliz!!'
}, {
  initials: 'LP',
  name: 'Laura P.',
  role: 'Esteticista — Córdoba',
  quote: 'Mis clientas de pestañas y laminado amaron el nuevo servicio... vuelven cada 3 semanas por Brow Extensions también'
}, {
  initials: 'RM',
  name: 'Rocío M.',
  role: 'Lashista — Rosario',
  quote: 'Llené mi agenda en una sola semana ofreciendo el servicio'
}];
const resultImages = ['https://cdn.magicpatterns.com/uploads/eA7mtCbRQrGw8Qn2PutU2F/WhatsApp_Image_2026-05-03_at_07.20.44.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/wL6aGDqFb48777ZA8eDtJx/WhatsApp_Image_2026-05-03_at_06.59.12.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/aL8Qcf1YcrbW3qCyv9ZFv8/WhatsApp_Image_2aa026-05-14_at_16.46.06_(3).jpg', 'https://cdn.magicpatterns.com/uploads/mvG1ANNPzfchqGvTXf38pD/WhatsApp_Image_2026-0a5-14_at_16.46.08_(2).jpg', 'https://cdn.magicpatterns.com/uploads/9j9jP7BzwVhbFaN7jSZsoS/WhatsApp_Image_2026-05-14_at_16.46.08_(d1).jpg', 'https://cdn.magicpatterns.com/uploads/uhsK2vLqDUXg7y7Y8cFcaL/WhatsApp_Images_2026-05-14_at_16.46.08_(3).jpg'];
const browTechniqueImages = ['https://cdn.magicpatterns.com/uploads/j5JTBTtCXaaFoDdZcPAaia/ChatGPT_Image_124_may_2026,_18_58_31.png', 'https://cdn.magicpatterns.com/uploads/cXWTGoBn2BYkM77XrHDfS8/WhatsApp_Image_2026-05-14_at_1a6.46.10_(2).jpg', 'https://cdn.magicpatterns.com/uploads/rY5WRbTAZQZQeX9CNFMbog/WhatsApp_Image_2026-05-14_at_16s.46.06_(2).jpg'];
export function HeroSection() {
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  const [browSlide, setBrowSlide] = useState(0);
  const [alumnasCount, setAlumnasCount] = useState(0);
  const statsRef = useRef<HTMLDivElement | null>(null);
  const hasAnimatedRef = useRef(false);
  useEffect(() => {
    if (!statsRef.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimatedRef.current) {
          hasAnimatedRef.current = true;
          const target = 357;
          const duration = 2000;
          const startTime = performance.now();
          const step = (now: number) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setAlumnasCount(Math.floor(eased * target));
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              setAlumnasCount(target);
            }
          };
          requestAnimationFrame(step);
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBrowSlide(prev => (prev + 1) % browTechniqueImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'El rubro beauty está ',
    bold: 'cada vez más saturado',
    after: ''
  }, {
    emoji: '❌',
    before: 'Hay demasiadas lashistas ',
    bold: 'ofreciendo lo mismo',
    after: ''
  }, {
    emoji: '❌',
    before: 'Las clientas ya ',
    bold: 'no se sorprenden fácilmente',
    after: ''
  }, {
    emoji: '❌',
    before: 'Querés diferenciarte pero ',
    bold: 'no sabés con qué',
    after: ''
  }, {
    emoji: '❌',
    before: 'Ves técnicas internacionales en redes… pero ',
    bold: 'nadie las enseña bien en Argentina',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240] space-y-[0px]" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <div className="text-center mb-8" data-id="element-105">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-106">
            <span data-id="element-107"></span>
            <span data-id="element-108">50% OFF - CUPOS LIMITADOS</span>
          </div>

          <h2 className="md:text-5xl font-black mb-4 max-w-5xl mx-auto uppercase text-[#FFFFFF] text-[27px]" data-id="element-109">
            <span className="text-[#FACC15]" data-id="element-110">BROW EXTENSIONS:</span> La Nueva
            Tendencia Que Está por Explotar en Argentina✨
          </h2>
          <h3 className="md:text-3xl font-bold mb-8 max-w-5xl mx-auto uppercase text-[#FC9DFF] text-[20px]" data-id="element-111">
            Y podés ser una de las primeras en ofrecerlo...
          </h3>

          <div className="flex justify-center mb-8" data-id="element-112">
            <div className="w-full max-w-lg mt-[-20px] mb-[-20px]" data-id="element-113">
              <div className="relative" data-id="element-114">
                <div className="overflow-hidden rounded-lg shadow-2xl" data-id="element-115">
                  <div className="flex transition-transform duration-500 ease-in-out" style={{
                  transform: `translateX(-${browSlide * 100}%)`
                }} data-id="element-116">
                    {browTechniqueImages.map((img, index) => <img key={index} src={img} alt={`Brow Extensions - Técnica Hiperrealista ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 aspect-square object-cover" data-id="element-117" />)}
                  </div>
                </div>
                <button onClick={() => setBrowSlide(prev => (prev - 1 + browTechniqueImages.length) % browTechniqueImages.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Anterior" data-id="element-118">
                  <ChevronLeftIcon className="w-5 h-5" data-id="element-119" />
                </button>
                <button onClick={() => setBrowSlide(prev => (prev + 1) % browTechniqueImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Siguiente" data-id="element-120">
                  <ChevronRightIcon className="w-5 h-5" data-id="element-121" />
                </button>
                <div className="flex justify-center gap-2 mt-3" data-id="element-122">
                  {browTechniqueImages.map((_, index) => <button key={index} onClick={() => setBrowSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${browSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-123" />)}
                </div>
              </div>
            </div>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto pt-[0px] pb-[0px] text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FFFFFF]" data-id="element-124">
            ✨ Aprendé la técnica hiperrealista que complementa pestañas,
            microblading y laminado.
          </p>

          <p className="md:text-2xl max-w-4xl mx-auto text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FC9DFF] pt-[5px] pb-[5px]" data-id="element-125"></p>

          <div className="rounded-xl p-6 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet pt-[15px] pb-[15px] mt-[15px] mb-[15px] pl-[0px] pr-[0px]" data-id="element-126">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[15px]" data-id="element-127">
              ✨ Ofrecé un servicio PREMIUM que ya es FUROR en Europa y LATAM🔥
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-128"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-129">
          <CTAButton text="QUIERO SER LA PRIMERA👉🏻" href={CHECKOUT_URL} size="large" className="w-full md:w-auto text-2xl animate-pulse-green" data-id="element-130" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-131">
          <h3 className="md:text-3xl text-center uppercase text-[10px] font-[400] text-[#FFFFFF] pt-[15px] pb-[15px] mt-[10px] mb-[10px]" data-id="element-132">
            🛡️ Garantía 7 días 🔒 Pago seguro 💳 Mercado Pago ⭐+357 Alumnas
            ⚡Acceso en 5 minutos
          </h3>

          <div ref={statsRef} className="mt-6 rounded-3xl bg-[#1a0124] border border-[#FC9DFF]/30 shadow-2xl p-6 md:p-7" data-id="element-133">
            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-6 mb-7" data-id="element-134">
              <div className="text-left" data-id="element-135">
                <div className="text-white font-black text-[40px] leading-none tracking-tight tabular-nums" data-id="element-136">
                  +{alumnasCount}
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-137">
                  alumnas en Europa y Latinoamérica
                </div>
              </div>
              <div className="text-left" data-id="element-138">
                <div className="text-white font-black text-[40px] leading-none tracking-tight" data-id="element-139">
                  27
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-140">
                  clases completamente listas
                </div>
              </div>
              <div className="text-left" data-id="element-141">
                <div className="text-white font-black text-[40px] leading-none tracking-tight flex items-baseline gap-1" data-id="element-142">
                  4.9
                  <span className="text-[24px] text-white/70" data-id="element-143">/5</span>
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug flex items-center gap-1" data-id="element-144">
                  calificación
                  <StarIcon className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-145" />
                </div>
              </div>
              <div className="text-left" data-id="element-146">
                <div className="text-[40px] leading-none" data-id="element-147">🌎</div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-148">
                  Todo el mundo hispanohablante
                </div>
              </div>
            </div>

            {/* Testimonial cards */}
            <div className="space-y-3" data-id="element-149">
              {heroTestimonials.map((t, i) => <div key={i} className="rounded-2xl border border-[#FC9DFF]/40 bg-[#2F0240]/60 p-4 flex gap-3 items-start" data-id="element-150">
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#9C16A3] flex items-center justify-center text-[#FC9DFF] font-black text-sm" data-id="element-151">
                    {t.initials}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-152">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-153">
                      {Array.from({
                    length: 5
                  }).map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-154" />)}
                    </div>
                    <p className="text-white font-bold text-[15px] leading-snug mb-1" data-id="element-155">
                      "{t.quote}"
                    </p>
                    <p className="text-white/70 text-xs leading-snug" data-id="element-156">
                      — {t.name} | {t.role}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400] pt-[20px] pb-[20px]" data-id="element-157">
          <h3 className="md:text-4xl font-black mb-8 text-center font-[Inter,_sans-serif] text-[24px] text-[#FFFFFF]" data-id="element-158">
            Si sos lashista, esteticista o cosmetóloga... esto te va a sonar
            familiar:
          </h3>
          <div className="space-y-4" data-id="element-159">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-160">
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-161">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-162">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-163">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
          <p className="text-center text-base md:text-lg font-semibold text-[#FC9DFF] mt-8 italic leading-relaxed" data-id="element-164"></p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-165">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-166">
            <p className="md:text-xl font-bold mb-4 text-[18px] font-[Montserrat,_sans-serif] text-[#FACC15]" data-id="element-167">
              Y seguramente a muchas de tus clientas les sucede que...
            </p>
            <p className="md:text-lg text-white mb-4 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-168">
              Ya se realizaron{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-169">
                microblading o sombreado de cejas
              </span>
              .
            </p>
            <p className="md:text-lg text-white mb-3 text-[16px] font-[500] font-[Montserrat,_sans-serif]" data-id="element-170">
              Pero siguen sintiendo que:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-171">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-172">
                ❌ las cejas se ven "dibujadas"
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-173">
                ❌ les falta textura real
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-174">
                ❌ quieren un acabado más natural
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-175">
                ❌ desean más hiperrealismo
              </li>
            </ul>
            <div className="my-5" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/vubQeaQEpXXQL9tzzdahZt/ChatGPT_Image_15_may_2026,_01_18_18.png" alt="Comparación cejas con y sin Brow Extensions" loading="lazy" className="w-full rounded-xl shadow-lg" data-id="element-177" />
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-178">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[22px]" data-id="element-179">
            La realidad es que ya no alcanza con hacer pestañas, microblading o
            laminado.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-180">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-181">
            <p className="md:text-xl font-bold text-white mb-4 text-[18px] font-[Montserrat,_sans-serif]" data-id="element-182">
              Las clientas buscan:
            </p>
            <ul className="space-y-3 text-left" data-id="element-183">
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-184">
                ✨ resultados mucho más realistas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-185">
                ✨ técnicas innovadoras
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-186">
                ✨ servicios exclusivos
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-187">
                ✨ profesionales actualizadas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-188">
                ✨ experiencias premium
              </li>
            </ul>
            <p className="md:text-lg text-[#FC9DFF] font-semibold mt-5 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-189"></p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-190">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-191">
            👉🏻Hoy, los salones y showroom que más crecen son los que incorporan
            tendencias antes que el resto.
          </h3>
        </div>

        <div className="max-w-2xl mx-auto mb-4 mt-8" data-id="element-192">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-193">
            <h4 className="md:text-2xl font-black mb-4 text-[20px] font-[Montserrat,_sans-serif] leading-snug text-[#FC9DFF]" data-id="element-194">
              Ahí es donde entra la Extensión de Cejas Pelo por Pelo.
            </h4>
            <p className="md:text-lg text-white mb-5 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-195">
              Una técnica que ya es un{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-196">
                éxito internacional
              </span>{' '}
              y que está a punto de explotar en Argentina...
            </p>
            <p className="md:text-lg mb-3 text-[16px] font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF]" data-id="element-197">
              Porque permite:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-198">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-199">
                ✔ reconstruir cejas despobladas
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-200">
                ✔ corregir asimetrías
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-201">
                ✔ crear efecto hiperrealista
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-202">
                ✔ rejuvenecer el rostro
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-203">
                ✔ complementar microblading
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-204">
                ✔ generar mantenimientos recurrentes
              </li>
            </ul>
            <p className="md:text-lg font-bold mt-5 mb-4 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed text-[#FFFFFF]" data-id="element-205">
              Y lo mejor: todavía hay MUY poca competencia.
            </p>
          </div>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-206">
          <div className="relative" data-id="element-207">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-208">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-209">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-210" />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-211">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-212" />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-213">
            ✨Ejemplos reales Brow Extensions✨
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-214">
          <h3 className="md:text-4xl font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF] mt-[0px] mb-[0px] text-[22px]" data-id="element-215">
            ¿Te imaginás poder ofrecerlo primero en tu zona...
          </h3>
          <p className="md:text-lg text-white text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed mt-[30px] mb-[30px]" data-id="element-216">
            Las mismas clientas que vuelven todos los meses por{' '}
            <span className="font-bold text-[#FC9DFF]" data-id="element-217">
              pestañas o laminado
            </span>
            … pueden convertirse en tus próximas clientas Brow✨
          </p>
          <p className="md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif] pt-[0px] pb-[0px] text-[30px]" data-id="element-218">
            Es por eso que creamos el Programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-219">BROW EXTENSIONS</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-220">
          <img src="https://cdn.magicpatterns.com/uploads/68QWgGoKk9HTa8pZ5e2tNV/mockup_dominando_shopify_(1).png" alt="Programa Brow Extensions - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-221" />
          <p className="text-center md:text-lg font-medium px-2 font-[Montserrat,_sans-serif] text-[#FC9DFF] text-[20px] pt-[10px] pb-[10px] mt-[0px] mb-[0px]" data-id="element-222">
            🏆 El sistema más completo de extensión de cejas pelo por pelo y
            negocio para profesionales beauty de Argentina ✨
          </p>
        </div>
      </div>
    </section>;
}